import TrustPilotImage from '../../../fastlane/TrustPilotImage/TrustPilotImage';

import styles from './TrustPilotReviews.styles.scss';

export const TrustPilotReviews = () => <TrustPilotImage className={styles.trustpilot} />;
